"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DndGrid = void 0;
const react_1 = __importStar(require("react"));
const core_1 = require("@dnd-kit/core");
const sortable_1 = require("@dnd-kit/sortable");
const grid_1 = require("../grid/grid");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const sortable_wrapper_1 = require("./sortable-wrapper");
const item_wrapper_1 = require("./item-wrapper");
function DndGrid({ value, onChange, columns, GridComponent = grid_1.Grid, SortableWrapperComponent = sortable_wrapper_1.SortableWrapper, ItemWrapperComponent = item_wrapper_1.ItemWrapper, ItemComponent, }) {
    const [activeItem, setActiveItem] = react_1.useState(null);
    const sensors = core_1.useSensors(core_1.useSensor(core_1.MouseSensor, {
        activationConstraint: { delay: 250, tolerance: 5 },
    }), core_1.useSensor(core_1.TouchSensor));
    const handleDragStart = event_callback_hook_1.useEventCallback((event) => {
        setActiveItem(event.active.id);
    });
    const handleDragEnd = event_callback_hook_1.useEventCallback((event) => {
        const { active, over } = event;
        if (active.id !== (over === null || over === void 0 ? void 0 : over.id) && over != null) {
            const oldIndex = value.indexOf(active.id);
            const newIndex = value.indexOf(over.id);
            onChange(sortable_1.arrayMove(value, oldIndex, newIndex));
        }
        setActiveItem(null);
    });
    const handleDragCancel = event_callback_hook_1.useEventCallback(() => {
        setActiveItem(null);
    });
    return (react_1.default.createElement(core_1.DndContext, { sensors: sensors, collisionDetection: core_1.closestCenter, onDragStart: handleDragStart, onDragEnd: handleDragEnd, onDragCancel: handleDragCancel },
        react_1.default.createElement(sortable_1.SortableContext, { items: value, strategy: sortable_1.rectSortingStrategy },
            react_1.default.createElement(GridComponent, { columns: columns }, value.map((item) => (react_1.default.createElement(SortableWrapperComponent, { key: item, id: item },
                react_1.default.createElement(ItemComponent, { id: item })))))),
        react_1.default.createElement(core_1.DragOverlay, { adjustScale: false }, activeItem ? (react_1.default.createElement(ItemWrapperComponent, { overlay: true },
            react_1.default.createElement(ItemComponent, { id: activeItem }))) : null)));
}
exports.DndGrid = DndGrid;
//# sourceMappingURL=dnd-grid.js.map